import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchReservations(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('reservation/agent/reservations', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteReservation(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`reservation/agent/reservations/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
